(function () {
    // Ugrađeni hr-ees alati. Žive na GitHub Pagesu, dakle na drugoj domeni,
    // pa se visina NE može izmjeriti odavde — contentDocument je zabranjen.
    // Alat je javlja sam porukom {wnVisina}, a mi je samo primimo.
    //
    // simulator.hbs ima vlastitu, drukčiju izvedbu: EES-RH je u assets/ teme,
    // dakle isti origin, pa se tamo visina čita izravno i grafovi na canvasu
    // se pri promjeni teme ponovno iscrtavaju. Dvije izvedbe postoje jer su
    // dva alata na dvije domene, ne slučajno.
    var HOST = 'https://alt-aneri.github.io';

    function tema() {
        return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
    }

    document.addEventListener('DOMContentLoaded', function () {
        var okviri = document.querySelectorAll('iframe[data-wn-frame]');
        if (!okviri.length) {
            return;
        }

        Array.prototype.forEach.call(okviri, function (frame) {
            // Tema ide kroz URL prije učitavanja da nema bljeska krive teme.
            var src = frame.getAttribute('src');
            frame.setAttribute('src', src + (src.indexOf('?') > -1 ? '&' : '?') +
                'embed=1&theme=' + tema());
        });

        window.addEventListener('message', function (ev) {
            // Prima se samo s domene na kojoj alat živi i samo očekivani oblik
            // poruke; sve ostalo na stranici može slati što hoće.
            if (ev.origin !== HOST) {
                return;
            }
            var d = ev.data;
            if (!d || typeof d !== 'object' || typeof d.wnVisina !== 'number') {
                return;
            }
            Array.prototype.forEach.call(okviri, function (frame) {
                if (frame.contentWindow === ev.source) {
                    frame.style.height = d.wnVisina + 'px';
                }
            });
        });
    });
})();
